import { Addresses, ContractName } from "@src/models";

export const contractAddresses: Addresses = {
  // Ethereum
  "1": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
    [ContractName.Lido]: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
  },
  // Base
  "8453": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
  },
  // Avalanche
  "43114": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
  },
  // Arbitrum
  "42161": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
  },
  // Optimism
  "10": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
  },
  // Polygon
  "137": {
    [ContractName.SwapperRouter]: "0x595F4634B91AD6dc548c1b9DC96b07858c33369f",
    [ContractName.FeeCollector]: "0x757965b16169E21535A0f405140097d83BF10Ec8",
    [ContractName.SwapperTransferProxy]:
      "0x10b544281c8b3a04D94509A92e2E0ad9FB66aeDC",
  },
  // ETH sepolia
  "11155111": {
    [ContractName.SwapperRouter]: "0xEacD8C9Ab2FB0e5948B541EDE2d0A9AfF6bDd14E",
    [ContractName.FeeCollector]: "0x124eC2Fde4eE78255ED6371B3B401C854de77De2",
    [ContractName.SwapperTransferProxy]:
      "0x60DAE54bF2D3eE332346749AbB0b35Af4F264031",
    [ContractName.Lido]: "0x3e3FE7dBc6B4C189E7128855dD526361c49b40Af",
  },
  // Base sepolia
  "84532": {
    [ContractName.SwapperRouter]: "0xEacD8C9Ab2FB0e5948B541EDE2d0A9AfF6bDd14E",
    [ContractName.FeeCollector]: "0xBf2399C79cE4aA60795DC7E0f2A2B536eD93e63b",
    [ContractName.SwapperTransferProxy]:
      "0x60DAE54bF2D3eE332346749AbB0b35Af4F264031",
  },
};
